import React, { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import AutoSizer from "react-virtualized-auto-sizer";

import { isMobile } from 'react-device-detect';

import IDXDetailChart from './IDXDetailChart';
import IDXCandleStickIndayChart from './IDXCandleStickIndayChart';
import CandleStickHistChart from '../share-components/CandleStickHistChart';
import { IDXSumaryPopup } from './IDXSumary';
import IDXForeignTrade from './IDXForeignTrade';
import IDXNumberStockChart from './IDXNumberStockChart';
import IDXValueScaleChart from './IDXValueScaleChart';
import IDXTop from './IDXTop';
import IDXHist from './IDXHist';
import IDXForeignBuyChart from './IDXForeignBuyChart';

import { priceToNumber } from '../../helpers/utils';
import { constHostAddressConfig } from '../../helpers/constData';

export default memo(function IDXPopupContent(props) {
    const { indexCode, priorIndex } = props;
    const language = useSelector((state) => state.gShared.language);
    const userName = useSelector((state) => state.gUser.userName ?? "");
    const { t } = useTranslation();
    //
    const [chartType, setChartType] = useState("D");

    //
    const _handleChangeChartType = (type) => {
        setChartType(type);
    }

    //
    return (
        // <div className='h-100'>aasdasd</div>
        <Tabs className='d-flex flex-column h-100'>
            <TabList>
                <Tab>{t("tongQuan")}</Tab>
                <Tab>{t("bieuDoKyThuat")}</Tab>
                <Tab>TOP</Tab>
                <Tab>{t("gdNDTNN")}</Tab>
                <Tab>{t("giaQuaKhu")}</Tab>
            </TabList>
            <TabPanel style={{ flex: 1 }}>
                {isMobile ? (
                    <AutoSizer>
                        {({ height, width }) => {
                            return (
                                <div style={{ height: height, width: width }}>
                                    <div className="scroll-styled" >
                                        <div>
                                            {chartType !== "D" ? (
                                                <CandleStickHistChart code={indexCode} type="IDX" chartType={chartType} style={{ height: '250px' }} />
                                            ) : (
                                                <IDXCandleStickIndayChart indexCode={indexCode} style={{ height: '250px' }} />
                                            )}
                                        </div>
                                        <div className={"text-center listoption"} style={{ paddingTop: 10, paddingBottom: 30 }}>
                                            <button className={(chartType === "D" ? "active" : "")} onClick={() => _handleChangeChartType("D")} onTouchStart={() => _handleChangeChartType("D")}>{t("homNay")}</button>
                                            <button className={(chartType === "W" ? "active" : "")} onClick={() => _handleChangeChartType("W")} onTouchStart={() => _handleChangeChartType("W")}>1 {t("tuan")}</button>
                                            <button className={(chartType === "1M" ? "active" : "")} onClick={() => _handleChangeChartType("1M")} onTouchStart={() => _handleChangeChartType("1M")}>1 {t("thang")}</button>
                                            {/* <button className={(chartType === "3M" ? "active" : "")} onClick={() => _handleChangeChartType("3M")} onTouchStart={() => _handleChangeChartType("3M")}>3 {t("thang")}</button>
                                            <button className={(chartType === "6M" ? "active" : "")} onClick={() => _handleChangeChartType("6M")} onTouchStart={() => _handleChangeChartType("6M")}>6 {t("thang")}</button>
                                            <button className={(chartType === "1Y" ? "active" : "")} onClick={() => _handleChangeChartType("1Y")} onTouchStart={() => _handleChangeChartType("1Y")}>1 {t("nam")}</button>
                                            <button className={(chartType === "5Y" ? "active" : "")} onClick={() => _handleChangeChartType("5Y")} onTouchStart={() => _handleChangeChartType("5Y")}>5 {t("nam")}</button> */}
                                        </div>
                                        <IDXSumaryPopup indexCode={indexCode} /></div>
                                </div>
                            )
                        }}
                    </AutoSizer>
                ) : (


                    <div className='d-flex h-100' >
                        <div className='d-flex flex-column' style={{ width: '66%' }}>
                            <div style={{ flex: 1 }}>
                                {chartType !== "D" ? (
                                    <CandleStickHistChart code={indexCode} type="IDX" chartType={chartType} />
                                ) : (
                                    <IDXCandleStickIndayChart indexCode={indexCode} />
                                )}
                            </div>
                            <div className={"text-center listoption"} style={{ paddingTop: 10, paddingBottom: 30 }}>
                                <button className={(chartType === "D" ? "active" : "")} onClick={() => _handleChangeChartType("D")} onTouchStart={() => _handleChangeChartType("D")}>{t("homNay")}</button>
                                <button className={(chartType === "W" ? "active" : "")} onClick={() => _handleChangeChartType("W")} onTouchStart={() => _handleChangeChartType("W")}>1 {t("tuan")}</button>
                                <button className={(chartType === "1M" ? "active" : "")} onClick={() => _handleChangeChartType("1M")} onTouchStart={() => _handleChangeChartType("1M")}>1 {t("thang")}</button>
                                {/* <button className={(chartType === "3M" ? "active" : "")} onClick={() => _handleChangeChartType("3M")} onTouchStart={() => _handleChangeChartType("3M")}>3 {t("thang")}</button>
                                <button className={(chartType === "6M" ? "active" : "")} onClick={() => _handleChangeChartType("6M")} onTouchStart={() => _handleChangeChartType("6M")}>6 {t("thang")}</button>
                                <button className={(chartType === "1Y" ? "active" : "")} onClick={() => _handleChangeChartType("1Y")} onTouchStart={() => _handleChangeChartType("1Y")}>1 {t("nam")}</button>
                                <button className={(chartType === "5Y" ? "active" : "")} onClick={() => _handleChangeChartType("5Y")} onTouchStart={() => _handleChangeChartType("5Y")}>5 {t("nam")}</button> */}
                            </div>
                        </div>
                        <div className="boxinfo--right">
                            <AutoSizer>
                                {({ height, width }) => {
                                    return (
                                        <div className="tbl__popup" style={{ height: height, width: width }}>
                                            <div className="scroll-styled">
                                                <IDXSumaryPopup indexCode={indexCode} />
                                                <IDXSumaryChart indexCode={indexCode} />
                                            </div>
                                        </div>
                                    )
                                }}
                            </AutoSizer>
                        </div>
                    </div>)}
            </TabPanel>
            <TabPanel style={{ flex: 1 }}>
                {/* bieu do ky thuat */}
                <iframe style={{ height: '100%', width: '100%' }} src={constHostAddressConfig.ApiTVSIAddress + `chart?symbol=${indexCode}&language=${language}&p_username=${userName}`} title=""></iframe>
            </TabPanel>
            <TabPanel style={{ flex: 1 }}>
                <IDXTop indexCode={indexCode} />
            </TabPanel>
            <TabPanel Name='d-flex h-100' style={{ flex: 1 }}>
                {/* gd NDT NN */}
                <div className='d-flex h-100' >
                    <IDXForeignTrade indexCode={indexCode} />
                </div>
            </TabPanel>
            <TabPanel style={{ flex: 1 }}>
                <IDXHist indexCode={indexCode} />
            </TabPanel>
        </Tabs>
    )
}, (prevProps, nextProps) => {
    if (prevProps.indexCode === nextProps.indexCode && prevProps.priorIndex === nextProps.priorIndex) {
        return true;
    }
    return false;
})

//
const IDXSumaryChart = memo(function (props) {
    const { indexCode } = props;

    const { t } = useTranslation();

    const i_counter = useSelector(state => state.gIndex.indexInfos.find(item => item.indexCode === indexCode)?.counter);
    const indexInfo = useSelector(state => state.gIndex.indexInfos.find(item => item.indexCode === indexCode)) ?? {};
    //
    return (
        <>
            <div className="titletabs text-uppercase">{t("soLuongCP")} {t("tang")}, {t("giam")}, {t("khongDoi")}</div>
            {/* <div className="pd_8 box__content--titlepb fs-14 font-weight-bold text-center">{t("soLuongCP")} {t("tang")}, {t("giam")}, {t("khongDoi")}</div> */}
            <div className="pd_8">
                <IDXNumberStockChart style={{ height: 200 }} numberUp={indexInfo.up} numberDown={indexInfo.down} numberNoChange={indexInfo.noChange} />
            </div>

            <div className="titletabs text-uppercase">{t("phanBoDongTien")}</div>
            {/* <div className="pd_8 box__content--titlepb fs-14 font-weight-bold text-center">{t("phanBoDongTien")}</div> */}
            <div className="pd_8">
                <IDXValueScaleChart style={{ height: 200, maxWidth: 400, margin: '0 auto' }}
                    tradedValueUp={priceToNumber(indexInfo?.totalTradedValueUp)}
                    tradedValueDown={priceToNumber(indexInfo?.totalTradedValueDown)}
                    tradedValueNoChange={priceToNumber(indexInfo?.totalTradedValueNoChange)} />
            </div>
        </>
    )
})